

  <div class="list-wrapper">

    <div class="progress-container ms-1 me-1">
    
      <div class="progress-header">
        <span class="fw-bold">Faltante</span>
        <span>Capturadas: <strong>{{totalCapturadas}}/{{totalVersiones}}</strong></span>
      </div>
    
      <div class="progress custom-progress">
        <div class="progress-bar  pe-2" role="progressbar" [style.width.%]="progress">
          <div class="d-flex justify-content-end align-items-center pe-2" *ngIf="progress >=10 ">{{progress}}%</div>
        </div>

        <!-- Porcentaje fuera -->
        <span 
          class="progress-outside"
          *ngIf="progress < 10">
          {{progress}}%
        </span>
      </div>
    
    </div>

     <div class="card bg-gray mt-3">
        <div class="card-body px-1">
          <h5>{{box.campana}}</h5>
          <hr>

          <div class="info-row">
            <span>Consecutivo</span>
            <b>{{box.consec}}</b>
          </div>

          <div class="info-row">
            <span>Sucursal</span>
            <b>{{box.sucursal}}</b>
          </div>

          <div class="info-row">
            <span>Estatus de captura</span>
            <b *ngIf="box.hoot_status === 0">Pendiente</b>
            <b *ngIf="box.hoot_status === 1">En proceso</b>
            <b *ngIf="box.hoot_status === 2">Finalizada</b>
          </div>

        </div>
      </div>


    <div class="title">Listado de productos</div>

    <div class="card" *ngFor="let item of materials">
      <div class="product-info">
        <div class="img-container" (click)="onOpenImage(item)">
            <img [src]="item.versiones[0]?.url || 'assets/images/example-mat.png'" alt="Producto" class="product-img" />
        </div>
 
        <div class="info">
          <div class="product-title">{{ item.nombre }}</div>
          <!--<div class="sent">Enviado: {{ item.cantidad }}</div>-->
        </div>
      </div>

      <div class="product-table">
        <div class="label">Enviados</div>
        <div class="label">Capturadas</div>
        <div class="label">{{ item.versiones.length != 0 ? 'Acciones' : ''}}</div>

        <div class="value">{{ item.versiones.length }}</div>
        <div class="value">{{ item.capturas }}</div>
        <div class="icons" >
          <!-- <ng-container *ngIf="item.versiones.length != 0">-->
          <ng-container>
            <button *ngIf="canOmit(item)" class="icon-btn" aria-label="Omit" (click)="omitGroup(item)">
              <i class="pi pi-ban"></i>
            </button>
            <button class="icon-btn" aria-label="Ver" (click)="onVersionList(item)">
              <i class="pi pi-eye"></i>
            </button>
            <button class="icon-btn" aria-label="Capturar" (click)="onCapture(item)">
              <i class="pi pi-camera"></i>
            </button>
          </ng-container>
        </div>
      </div>
    </div>
    <div *ngIf="loaded && box.hoot_status != 2" class="p-d-flex p-jc-center" style="margin-top: 20px;">
      <button pButton type="button" label="Finalizar caja" icon="pi pi-check" class="p-button-success" (click)="omitBox()"></button>
    </div>

    <div *ngIf="loaded && materials.length == 0">
      <p>No hay materiales disponibles para esta caja.</p>
    </div>
  </div>
